import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-content" }
const _hoisted_2 = { class: "flex flex-col gap-controls" }
const _hoisted_3 = { class: "heading-4" }
const _hoisted_4 = { class: "flex flex-col gap-controls" }
const _hoisted_5 = { class: "heading-4" }

import DocumentLinkCard from '@/components/documents/DocumentLinkCard.vue'
import { useDemoMode } from '@/core/composables/company/useDemoMode'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Documents'
},
  __name: 'Documents',
  setup(__props) {



const { t } = useI18n()
const { isInDemoMode } = useDemoMode()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_unref(t)('reports.documents.info_text')), 1),
    (!_unref(isInDemoMode))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('reports.documents.documents_for_refunds')), 1),
            _createVNode(DocumentLinkCard, {
              link: _unref(t)('links.travel_expense_report'),
              "info-text": _unref(t)('reports.documents.travel_refund.info_text'),
              "card-header": 
            _unref(t)('reports.documents.travel_refund.card_header', { year: 2025 })
          
            }, null, 8, ["link", "info-text", "card-header"]),
            _createVNode(DocumentLinkCard, {
              link: _unref(t)('links.expense_report'),
              "info-text": _unref(t)('reports.documents.expense_refund.info_text'),
              "card-header": _unref(t)('reports.documents.expense_refund.card_header')
            }, null, 8, ["link", "info-text", "card-header"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)('reports.headings.old_documents')), 1),
            _createVNode(DocumentLinkCard, {
              link: _unref(t)('links.travel_expense_report_2024'),
              "info-text": _unref(t)('reports.documents.travel_refund.info_text'),
              "card-header": 
            _unref(t)('reports.documents.travel_refund.card_header', { year: 2024 })
          
            }, null, 8, ["link", "info-text", "card-header"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})